import { EMAIL_COMMON_STYLES } from './styles';

export const EMAIL_FOOTER = `
<tr>
  <td style="color:${EMAIL_COMMON_STYLES.GRAY_COLOR}">
    <br>This email was sent by the Iowa DOT Project Priorities web application.
  </td>
</tr>`;
